<!-- components/SidebarEffect.vue -->
<template>
    <transition name="slide">
      <div v-if="visible" class="sidebar-overlay" @click.self="hide">
        <div class="sidebar-content">
          <div class="row mb-4 p-3 text-start">
            <span class="border-0 bg-white text-start" @click="hide">
              <i class="fa fa-x"></i>
            </span>
          </div>
          <!-- Render slot content here -->
          <slot />
        </div>
      </div>
    </transition>
  </template>
  
  <script lang="ts">
  import { Component, Vue, toNative } from 'vue-facing-decorator'
  
  @Component
  class SidebarEffect extends Vue {
    visible = false
  
    show() {
      this.visible = true
    }
  
    hide() {
      this.visible = false
    }
  }
  
  export default toNative(SidebarEffect)
  </script>
  
  <style scoped>
  .sidebar-overlay {
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 9999;
    display: flex;
    justify-content: flex-end;
  }
  .sidebar-content {
    width: 50vw;
    height: 100%;
    background-color: white;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.2);
    padding: 1.5rem;
    position: relative;
    overflow-y: auto;
  }
  .slide-enter-active,
  .slide-leave-active {
    transition: transform 0.3s ease;
  }
  .slide-enter-from,
  .slide-leave-to {
    transform: translateX(100%);
  }
  </style>
  